import { render, staticRenderFns } from "./ContactCategoryInput.vue?vue&type=template&id=59816699&"
import script from "./ContactCategoryInput.vue?vue&type=script&lang=ts&"
export * from "./ContactCategoryInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports